<template>
  <div
    v-if="address"
    class="store-address"
  >
    {{ address.line1 }} {{ address.line2 || '' }}<br />
    {{ address.postalCode }} {{ address.town }}{{ countryName }}
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  address: {
    line1: string;
    line2: string;
    postalCode: number | string;
    town: string;
    country: {
      name: string;
    };
  };
}>();

const countryName = computed(() => {
  const countryName = props.address.country?.name ?? props.address.country;
  return countryName?.length ? `, ${countryName}` : '';
});
</script>

<style lang="scss" scoped>
.store-address {
  margin-bottom: $pad;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
